import http from "@/utils/http";
//
/**
 *  登录接口
 */
//账号和密码登录
export function login(param) {
    return http.post(`/admin/login`, param)
}
//退出登录
export function quitApi(param) {
    return http.get('/admin/logout', param)
}
//获取当前登录用户的详细信息
export function infoApi(param) {
    return http.get('/admin/userInfo', param)
}
//修改当前登录的用户信息
export function modifyUserInfoApi(param) {
    return http.post('/admin/updateInfo', param)
}
//修改当前登录用户密码
export function modifyPassWordApi(param) {
    return http.post('/admin/updatePassword', param)
}



//查询当前用户的所有部门
export function getDepartApi(param) {
    return http.get('/admin/user/getDepart', param)
}
//查询当前用户的所有租户
export function getTenantApi(param) {
    return http.get('/admin/user/getTenant', param)
}
//切换部门和租户
export function updateDepTenatApi(param) {
    return http.post('/admin/updateDepTenat', param)
}
//查看当前用户的权限菜单
export function getPermissionApi(param) {
    return http.post('/admin/user/get_permission', param)
}

// 顶部导航
export function topNavApi(param) {
    return http.get('/admin/topNav', param)
}